import { useEffect } from 'react'

import { Global } from '@emotion/react'
import { useAtom } from 'jotai'

import type { LinkUrl, Navigation as NavigationType } from '@twisto/api-cms'
import { Flex } from '@twisto/components/atoms/flex'
import { Link } from '@twisto/components/atoms/link'
import { Logo } from '@twisto/components/atoms/logo'
import { useScrollPosition } from '@twisto/hooks'

import { getLinkUrl } from 'homepage/utils'

import { navigationThemeAtom } from './navigation-theme'
import * as styles from './navigation.styles'
import { PrimaryNavigationSlot } from './primary'
import { SecondaryNavigationSlot } from './secondary'

export const Navigation = ({
  primary,
  secondary,
  type,
  homeLink,
  theme,
}: NavigationType) => {
  const isScrolled = useScrollPosition() !== 0

  const [navigationTheme, setNavigationTheme] = useAtom(navigationThemeAtom)

  useEffect(() => {
    setNavigationTheme(theme ?? 'light')
  }, [theme, setNavigationTheme])

  return (
    <header
      css={[
        styles.header,
        isScrolled && styles.headerScrolled,
        theme ? styles[theme] : styles.light,
      ]}
    >
      <Global styles={styles.globalNavigationStyles} />
      <nav css={styles.navigation}>
        <Flex alignItems="center" css={styles.primaryContainer} wrap="noWrap">
          <Link to={getLinkUrl(homeLink as LinkUrl)}>
            <Logo
              inverse={navigationTheme === 'dark'}
              logo={type}
              variant="full"
            />
          </Link>

          <PrimaryNavigationSlot primaryNavigationContent={primary} />
        </Flex>
        <SecondaryNavigationSlot
          primaryNavigationContent={primary}
          secondaryNavigationContent={secondary}
        />
      </nav>
    </header>
  )
}
